export default "__VITE_ASSET__h9VG$6JZ__"